import { DateTime } from 'luxon';
import { ChatMessage } from '../models/chat-history.model';

export type ChatListItem =
  | { type: 'header'; key: string; label: string }
  | { type: 'message'; message: ChatMessage };

export function chatDayKey(date: Date): string {
  return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
}

export function chatDayLabel(date: Date, now = DateTime.now()): string {
  const d = DateTime.fromJSDate(date);
  if (!d.isValid) return '';
  if (d.hasSame(now, 'day')) return `Today at ${d.toFormat('h:mm a')}`;
  if (d.hasSame(now.minus({ days: 1 }), 'day')) return 'Yesterday';
  if (d.hasSame(now, 'week') && d <= now) return d.toFormat('cccc');
  return d.toFormat("ccc, MMM d 'at' h:mm a");
}

export function withDayHeaders(messages: ChatMessage[]): ChatListItem[] {
  const out: ChatListItem[] = [];
  let lastKey: string | null = null;
  const now = DateTime.now();

  for (const message of messages) {
    const ts = message.timestamp;
    if (!ts) {
      out.push({ type: 'message', message });
      continue;
    }
    const key = chatDayKey(ts);
    if (key !== lastKey) {
      const label = chatDayLabel(ts, now);
      if (label) out.push({ type: 'header', key, label });
      lastKey = key;
    }
    out.push({ type: 'message', message });
  }
  return out;
}

export function isServerMessageId(id?: string): boolean {
  if (!id) return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    id
  );
}
